import { Iterable } from 'ix';

import { IterableLike, ObservableLike } from '../../../WebRx';
import { ListItemsViewModel } from './ListItemsViewModel';

export function flattenItems<T>(
  item: T,
  itemsSource: (item: T) => IterableLike<T> | undefined,
): Iterable<T> {
  const items = itemsSource(item);

  return items == null
    ? Iterable.of(item)
    : Iterable.from(items)
        .flatMap(x => flattenItems(x, itemsSource))
        .startWith(item);
}

export class TreeListItemsViewModel<T> extends ListItemsViewModel<T> {
  public static displayName = 'TreeListItemsViewModel';

  constructor(
    source: ObservableLike<IterableLike<T>>,
    protected readonly itemsSource: (item: T) => IterableLike<T> | undefined,
  ) {
    super(source);
  }

  getItems() {
    return Iterable.from(this.getItemsSource()).flatMap(x =>
      this.flattenItems(x),
    );
  }

  getItemsForIndicies(indicies: IterableLike<number>) {
    return undefined;
  }

  getIndiciesForItems(items: IterableLike<T>) {
    return undefined;
  }

  protected flattenItems(item: T): Iterable<T> {
    return flattenItems(item, this.itemsSource);
  }
}



// WEBPACK FOOTER //
// ./src/Components/Common/ListItems/TreeListItemsViewModel.ts